export const PACKAGE_VERSION = '0.7.0'
